import React, { Component } from 'react';
import  { connect } from 'react-redux';
import { TwitterPicker } from 'react-color';
import { setColor } from '../../redux/actions/colors';
import { colorPickers } from '../../config/constants';


class ColorPickers extends Component {

    render() {
        const { colors, setColor, activeBuilderType } = this.props;

        return (
            <ul>
                {
                    colorPickers.map((el, i) => (
                        <li key={i} className="input-item-name">
                            { el.label }
                            <TwitterPicker
                                color={colors[activeBuilderType][el.colorKey]}
                                onChangeComplete={(color) => {
                                    setColor({
                                        activeBuilderType,
                                        targetColor: el.colorKey,
                                        color: color.hex
                                    });
                                }}
                            />
                        </li>
                    ))
                }
            </ul>
        );
    }
}


export default connect(
    state => ({
        colors: state.colors,
        activeBuilderType: state.activeBuilderType,
    }),
    {
        setColor,
    }
  )(ColorPickers);



